import { useContext } from 'react';
import { StoreContext, AppStore } from './StoreProvider';

export const useStore = (): AppStore => useContext(StoreContext);
